import React from "react";
import styles from "../Button/WhiteButton.module.css";
import { FaSearchPlus } from "react-icons/fa";
function WhiteButton(props) {
  const {name}=props
  return (
    <>
    
      <button className={styles.WhiteButton}>
          {name}
        <FaSearchPlus className={styles.icon} />
      </button>
    </>
  );
}

export default WhiteButton;
